import React from "react";
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import cogoToast from "cogo-toast";
import { Form, Formik } from "formik";
import { Form as FormLayout } from "react-bootstrap";
import { useDisableSecurityQuestionMutation } from "../../../../../redux/apiSlice";

const DisableSecurityQuestionModal = ({ 
    showDisableSecurityQuestionModal, 
    onHide, 
    details, 
    tableRef 
}) => {
    const [disableSecurityQuestion, { isLoading }] = useDisableSecurityQuestionMutation();

    const initialValues = {
        question: details?.question || "",
        userGroup: details?.userGroup || "trove",
        securityQuestionId: details?.id || details?.securityQuestionId || ""
    };

    return (
        <Modal
            show={showDisableSecurityQuestionModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isLoading ? "static" : true}
            keyboard={!isLoading}
        >
            <Formik
                initialValues={initialValues}
                onSubmit={(values) => {
                    const payload = {
                        userGroup: values.userGroup,
                        question: values.question,
                        securityQuestionId: values.securityQuestionId
                    };

                    disableSecurityQuestion(payload)
                        .unwrap()
                        .then(() => {
                            cogoToast.success("Security question disabled successfully");

                            if (tableRef?.current?.refresh) {
                                tableRef.current.refresh();
                            }

                            onHide();
                        })
                        .catch((error) => {
                            cogoToast.error(
                                error?.data?.message || "Failed to disable security question"
                            );
                        });
                }}
            >
                {({ values }) => (
                    <Form noValidate>
                        <Modal.Header>
                            <Modal.Title id="contained-modal-title-vcenter">
                                <span className="svg-icon svg-icon-lg svg-icon-primary mr-3">
                                    <SVG
                                        src={toAbsoluteUrl("/media/svg/icons/Shopping/Safe.svg")}
                                    />
                                </span>
                                Delete Security Question
                            </Modal.Title>
                            <button type="button" className="close" onClick={onHide}>
                                <span aria-hidden="true" className="d-block">×</span>
                                <span className="sr-only">Close</span>
                            </button>
                        </Modal.Header>

                        <Modal.Body className="px-10 py-5">
                            <FormLayout.Row>
                                <div style={{ width: "100%" }}>
                                    <p className="font-weight-bold mb-2">
                                        Security Question
                                    </p>
                                    <div className="form-control-plaintext">
                                        {values.question}
                                    </div>

                                    <small className="form-text text-muted">
                                        This security question will be disabled for all users.
                                    </small>
                                </div>
                            </FormLayout.Row>

                            <input 
                                type="hidden" 
                                name="securityQuestionId" 
                                value={values.securityQuestionId} 
                            />
                        </Modal.Body>

                        <Modal.Footer>
                            <button
                                type="button"
                                onClick={onHide}
                                className="btn btn-light btn-elevate px-4"
                                disabled={isLoading}
                            >
                                Close
                            </button>

                            <button
                                type="submit"
                                className="btn btn-danger btn-elevate px-4 ml-4"
                                disabled={isLoading}
                            >
                                {isLoading ? "Disabling..." : "Disable"}
                            </button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default DisableSecurityQuestionModal;
